export default "__VITE_ASSET__uzF2Gw$m__"